'use client';

import { FaroErrorBoundary } from '@grafana/faro-react';

/**
 * Root RUM error boundary. Reports (via Faro's own pushError) any error that
 * escapes the segment `error.tsx` boundaries — e.g. a `[locale]/layout.tsx` render
 * error, which its sibling `[locale]/error.tsx` cannot catch. A minimal,
 * provider-free `fallback` is supplied so such errors render recovery UI instead of
 * a blank screen (a fallback-less FaroErrorBoundary renders `null` on error).
 */
export function FaroErrorBoundaryWrapper({ children }: { children: React.ReactNode }) {
  return (
    <FaroErrorBoundary
      fallback={(_error, resetError) => (
        <main
          style={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontSize: 20, fontWeight: 600 }}>Something went wrong</h1>
          <p style={{ color: '#525252' }}>An unexpected error occurred. Please try again.</p>
          <button
            type="button"
            onClick={resetError}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 0,
              background: '#FA5002',
              color: 'white',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </main>
      )}
    >
      {children}
    </FaroErrorBoundary>
  );
}
